import React, { useState, useEffect } from "react";
import "./editdsr.scss";
import Sidebar from "../Sidebar";
import Header from "../../component/loaderComponent/Header/Header";
import { useDispatch } from "react-redux";
import { notify } from '../../services/notification';
import Loader from "../../component/loaderComponent/loaderComponent/Loader";
import { useParams, useNavigate } from "react-router-dom";
import { decode } from "base-64";
import { HiMenu, HiX } from "react-icons/hi";
import { MOBILE_BREAKPOINT, HTTP_STATUS } from "../../constants/constant";
import useMobileView from "../../constants/useMobileView";
import { DsrNameAction, UpdateDsrAction, DsrPincodeAction } from "../../actions/dsrAction";
import { PHONE_NUMBER_REGEX, EMAIL_REGEX } from "../../constants/regex/regex";
import { MdEdit } from "react-icons/md";

function EditDsr() {
  const [loading, setLoading] = useState(false);
  const [pincodeLoading, setPincodeLoading] = useState(false);
  const { isSidebarOpen, toggleSidebar } = useMobileView();
  const [emailError, setEmailError] = useState("");

  const MobileCode = "91";

  const [state, setState] = useState({
    name: "",
    employee_code: "",
    mobile_number: "",
    mobile_code: MobileCode,
    pincode: "",
    email: "",
    city: "",
    district: "",
    state: "",
    aps_code: "",
  });

  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (id) getDsrdata(decode(id));
  }, [id]);

  const getDsrdata = async (id) => {
    setLoading(true);
    try {
      const response = await dispatch(DsrNameAction(id));
      if (response?.status === 200) {
        setLoading(false);
        const dsrData = response?.data?.data;
        setState({
          name: dsrData.name || "",
          employee_code: dsrData.employee_code || "",
          mobile_number: dsrData.mobile_number || "",
          mobile_code: dsrData.mobile_code || MobileCode,
          aps_code: dsrData.aps_code || "",
          email: dsrData.email || "",
          // pincode: dsrData.pincode || "",
          // city: dsrData.city || "",
          // district: dsrData.district || "",
          // state: dsrData.state || "",
        });
      } else if (response === undefined) {
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  const fetchPincodeDetails = async (pincodeValue) => {
    setPincodeLoading(true);
    try {
      const response = await dispatch(DsrPincodeAction(pincodeValue));
      if (response?.status === 200 && response?.data?.data) {
        if (response?.data?.data?.length === 0) {
          notify.error("No Record Found");
          return;
        }
        const locationData = response?.data?.data?.[0];
        setState(prevState => ({
          ...prevState,
          city: locationData?.city || "",
          district: locationData?.district || "",
          state: locationData?.state || "",
        }));
      } else {
        // Clear fields if no data found
        setState(prevState => ({
          ...prevState,
          city: "",
          district: "",
          state: "",
        }));
      }
    } catch (error) {
      console.error('Error fetching pincode details:', error);
      notify.error('Failed to fetch location details');
      // Clear fields on error
      setState(prevState => ({
        ...prevState,
        city: "",
        district: "",
        state: "",
      }));
    } finally {
      setPincodeLoading(false);
    }
  };

  const validateEmail = (value) => {
    const gmailRegex = EMAIL_REGEX;
    if (value === "" || gmailRegex.test(value)) {
      setEmailError("");
      setState((prevState) => ({
        ...prevState,
        email: value.replace(/^ +/gm, ""),
      }));
    } else {
      setEmailError("Please enter a valid Gmail address");
      setState((prevState) => ({
        ...prevState,
        email: value,
      }));
    }
  };
  const isValidName = (name) => {
    const match = name.match(/[A-Za-z]/g); // find all alphabetic characters
    return match && match?.length >= 3;
  };
  const handleInputChange = (evt) => {
    let value = evt.target.value.replace(/^ +/gm, "");
    const { name } = evt.target;
    let newState = { ...state };

    if (name === "employee_code") {
      // Ensure prefix only once
      if (!value.startsWith("EMP-")) {
        value = `EMP-${value}`;
      }
      newState[name] = value;
    } else if (name === "pincode") {
      if (/^\d{0,6}$/.test(value)) {
        if (newState.pincode?.length <= 5 || value?.length <= newState.pincode?.length)
          newState.pincode = value;

        // If pincode is 6 digits, fetch location details
        if (value?.length === 6) {
          fetchPincodeDetails(value);
        } else {
          // Clear location fields if pincode is not 6 digits
          newState.city = "";
          newState.district = "";
          newState.state = "";
        }
      }
    } else {
      newState[name] = value;
    }
    setState(newState);
  };

  const validatePhoneNumber = (value) => {
    if (value === "" || PHONE_NUMBER_REGEX.test(value)) {
      setState((prevState) => ({
        ...prevState,
        mobile_number: value.replace(/^ +/gm, ""),
      }));
    }
  };

  const handleOnUpdateClick = async (e) => {
    e.preventDefault();
    if (!isValidName(state.name)) {
      notify.error("Name must contain at least three alphabetic characters.");
      return;
    }
    if (state.mobile_number?.length !== 10 || !PHONE_NUMBER_REGEX?.test(state.mobile_number)) {
      notify.error("Phone number must be exactly 10 digits and start with 6, 7, 8, or 9.");
      return;
    }
    setLoading(true);

    try {
      const payload = {
        name: state.name,
        mobile_code: state.mobile_code,
        mobile_number: state.mobile_number,
        aps_code: state.aps_code,
        email: state.email,
        employee_code: state.employee_code,
        // pincode: state.pincode,
        // city: state.city,
        // district: state.district,
        // state: state.state,
      };

      const response = await dispatch(UpdateDsrAction(payload, decode(id)));
      if (response?.status === 200) {
        setLoading(false);
        notify.success(response?.data?.message || 'DSR updated successfully');
        navigate("/dsr");
      } else if (response?.status === 400) {
        setLoading(false);
        notify.error(response?.data?.message);
      } else {
        setLoading(false);
        notify.error(response?.data?.message || 'Update failed');
      }
    } catch (error) {
      setLoading(false);
      notify.error(error?.data?.message || 'An error occurred');
    }
  };

  return (
    <div className="edit-dsr-container">
      <div className="edit-dsr-containerright">
        <Header title="Edit DSR" />
        <div className="edit-dsr">
          {loading ? (
            <Loader />
          ) : (
            <div className="form-div">
              {/* Name */}
              <div className="grid">
                <label className="label-edit-dsr">Name (<MdEdit />)</label>
                <input
                  type="text"
                  name="name"
                  value={state.name}
                  onChange={handleInputChange}
                  className="edit-dsr-input-field"
                  required
                />
              </div>

              {/* Employee Code */}
              <div className="grid">
                <label className="label-edit-dsr">Employee Code </label>
                <input
                  type="text"
                  name="employee_code"
                  value={state.employee_code}
                  onChange={handleInputChange}
                  className="edit-dsr-input-field"
                  readOnly
                />
              </div>

              {/* Employee Code */}
              {/* <div className="grid">
                <label className="label-edit-dsr">Employee Code</label>
                <input
                  type="text"
                  name="employee_code"
                  value={state?.employee_code}
                  onChange={handleInputChange}
                  readOnly
                  className="edit-dsr-input-field"
                  onFocus={() => {
                    if (!state.employee_code.startsWith("EMP-")) {
                      setState({ ...state, employee_code: "EMP-" });
                    }
                  }}
                />
              </div> */}

              {/* Phone Number */}
              <div className="grid">
                <label className="label-edit-dsr">Phone Number (<MdEdit />)</label>
                <div>
                  <input
                    type="text"
                    name="mobile_number"
                    value={state.mobile_number}
                    minLength={10}
                    maxLength={10}
                    onChange={(e) => validatePhoneNumber(e.target.value)}
                    className="edit-dsr-input-field"
                    title="Phone number must start with 6-9 and be 10 digits"
                  />
                  {state.mobile_number && state.mobile_number?.length !== 10 && (
                    <span className="error-message">
                      Phone number must be exactly 10 digits.
                    </span>
                  )}
                </div>
              </div>

              {/* Pincode */}
              {/* <div className="grid">
                <label className="label-edit-dsr">Pincode (<MdEdit />)</label>
                <div style={{ position: 'relative' }}>
                  <input
                    type="text"
                    name="pincode"
                    value={state.pincode}
                    onChange={handleInputChange}
                    className="edit-dsr-input-field"
                  />
                  {pincodeLoading && (
                    <span style={{
                      position: 'absolute',
                      right: '10px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      fontSize: '12px',
                      color: '#666'
                    }}>
                      Loading...
                    </span>
                  )}
                </div>
              </div> */}

              {/* City */}
              {/* <div className="grid">
                <label className="abel-edit-dsr-non-mandatory">City</label>
                <input
                  type="text"
                  name="city"
                  value={state.city}
                  onChange={handleInputChange}
                  className="edit-dsr-input-field"
                  readOnly
                  style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                />
              </div> */}

              {/* District */}
              {/* <div className="grid">
                <label className="abel-edit-dsr-non-mandatory">District</label>
                <input
                  type="text"
                  name="district"
                  value={state.district}
                  onChange={handleInputChange}
                  className="edit-dsr-input-field"
                  readOnly
                  style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                />
              </div> */}

              {/* State */}
              {/* <div className="grid">
                <label className="abel-edit-dsr-non-mandatory">State</label>
                <input
                  type="text"
                  name="state"
                  value={state.state}
                  onChange={handleInputChange}
                  className="edit-dsr-input-field"
                  readOnly
                  style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                />
              </div> */}

              {/* Aps Code */}
              <div className="grid">
                <label className="label-edit-dsr">Aps Code </label>
                <input
                  type="text"
                  name="aps_code"
                  value={state.aps_code}
                  onChange={handleInputChange}
                  className="edit-dsr-input-field"
                  readOnly
                />
              </div>

              {/* Email */}
              <div className="grid">
                <label className="abel-edit-dsr-non-mandatory">Email (<MdEdit />)</label>
                <input
                  type="email"
                  name="email"
                  value={state.email}
                  onChange={(e) => validateEmail(e.target.value)}
                  className="edit-dsr-input-field"
                />
              </div>
              <>
                {emailError && (
                  <span className="error-message-email">{emailError}</span>
                )}
              </>
              <div className="btn-notify">
                <button
                  onClick={() => navigate("/dsr")}
                  className="dsr-active"
                >
                  Close
                </button>
                <button
                  className="dsr-active"
                  type="button"
                  disabled={!state.name ||
                    !state.employee_code ||
                    !(state.mobile_number?.length == 10) ||
                    // state.employee_code?.length < 5  ||
                    // !(state.pincode?.length == 6) ||
                    emailError !== ""
                  }
                  onClick={handleOnUpdateClick}
                >
                  Update
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default EditDsr;